import * as api from 'saas/pco/zones/api';

export const PLACE_POINT = 'zone.PLACE_POINT';
export const PLACE_POINT_SUCCESS = 'zone.PLACE_POINT_SUCCESS';
export const DISPLAY_ADD = 'zone.DISPLAY_ADD';
export const DISPLAY_POINT = 'zone.DISPLAY_POINT';
export const HIDE_ADD = 'zone.HIDE_ADD';
export const HIDE_POINT = 'zone.HIDE_POINT';
export const CREATE_POINT = 'zone.CREATE_POINT';
export const CREATE_POINT_SUCCESS = 'zone.CREATE_POINT_SUCCESS';
export const CREATE_POINT_ERROR = 'zone.CREATE_POINT_ERROR';
export const SAVE_POINT = 'zone.SAVE_POINT';
export const DELETE_POINT = 'zone.DELETE_POINT';

export const placePoint = (point, top, left) => dispatch => {
  const updated = {
    ...point,
    coordinate: {
      x: Number(left),
      y: Number(top),
    },
  };

  dispatch({
    type: PLACE_POINT,
    point: updated,
  });

  return api.updatePoint(updated).then(_ =>
    dispatch({
      type: PLACE_POINT_SUCCESS,
      point,
    })
  );
};

export const createComment = (zone, comment, image) => dispatch => {
  dispatch({
    type: CREATE_POINT,
  });

  return api
    .createComment(zone, comment, image)
    .then(created =>
      dispatch({
        type: CREATE_POINT_SUCCESS,
        point: created,
      })
    )
    .catch(error =>
      dispatch({
        type: CREATE_POINT_ERROR,
        error,
      })
    );
};

export const savePoint = (point, image) => dispatch => {
  return api.updatePoint(point, image).then(updated =>
    dispatch({
      type: SAVE_POINT,
      point: updated,
    })
  );
};

export const deletePoint = point => dispatch => {
  return api.deletePoint(point).then(_ =>
    dispatch({
      type: DELETE_POINT,
      point,
    })
  );
};

export const displayAdd = () => ({
  type: DISPLAY_ADD,
});

export const hideAdd = () => ({
  type: HIDE_ADD,
});

export const displayPoint = point => ({
  type: DISPLAY_POINT,
  point,
});

export const hidePoint = () => ({
  type: HIDE_POINT,
});



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/actions/points.js